<template>
  <v-dialog v-model="show" max-width="400" persistent>
    <v-card>
      <v-card-title>Password Required</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="passwordInput"
          label="Password"
          :type="showPasswordField ? 'text' : 'password'"
          :append-inner-icon="showPasswordField ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showPasswordField = !showPasswordField"
          :error-messages="passwordError"
          @keyup.enter="handleVerify"
          autofocus
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleCancel" variant="outlined">Cancel</v-btn>
        <v-btn @click="handleVerify" color="primary" :loading="verifying">
          Access
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, computed } from 'vue'

export default {
  name: 'PasswordDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    verifying: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'verify', 'cancel'],
  setup(props, { emit }) {
    const passwordInput = ref('')
    const showPasswordField = ref(false)

    const show = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })

    const passwordError = computed(() => props.error)

    const handleVerify = () => {
      if (!passwordInput.value.trim()) {
        return
      }
      emit('verify', passwordInput.value)
    }

    const handleCancel = () => {
      emit('cancel')
    }

    return {
      show,
      passwordInput,
      showPasswordField,
      passwordError,
      handleVerify,
      handleCancel
    }
  }
}
</script>